import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api, { errMsg } from "../lib/api";
import Logo from "../components/Logo";

export const AuthShell = ({ title, children }) => (
  <div className="min-h-screen grid place-items-center bg-[#F7F5FB] px-4" data-testid="auth-shell">
    <div className="vmw-card w-full max-w-md p-8">
      <Logo className="h-10 mb-6" />
      <h1 className="font-display text-2xl font-bold text-[#1A1A2E] mb-2">{title}</h1>
      {children}
      <Link to="/login" className="text-sm text-primary font-semibold mt-6 inline-block" data-testid="back-to-login">← Back to sign in</Link>
    </div>
  </div>
);

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const r = await api.post("/auth/forgot-password", { email }); setDone(r.data.message); }
    catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthShell title="Forgot password">
      {done ? (
        <div className="flex gap-3 text-sm text-emerald-700 bg-emerald-50 rounded-lg p-3" data-testid="forgot-success"><MailCheck className="h-5 w-5 shrink-0" />{done} The link expires in 30 minutes.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-muted-foreground">Enter your registered work email and we'll send you a secure reset link.</p>
          <input type="email" required className="vmw-input" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
          {err && <p className="text-sm text-rose-600" data-testid="forgot-error">{err}</p>}
          <button className="vmw-gradient text-white w-full h-10 rounded-lg font-semibold inline-flex items-center justify-center gap-2" disabled={busy} data-testid="forgot-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}Send reset link</button>
        </form>
      )}
    </AuthShell>
  );
}
